import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AssistantChat from '../components/Assistant/AssistantChat';

const SETUP_WELCOME = {
  role: 'assistant',
  content:
    "Bonjour ! Je vois que votre abonnement est actif mais que sa configuration ne semble pas encore terminée. Sur quel appareil souhaitez-vous regarder votre IPTV ?",
  quick_replies: [
    'Fire TV Stick',
    'Android TV / Google TV',
    'Télévision Samsung',
    'Télévision LG',
    'Smartphone ou tablette',
    'Ordinateur',
    'Autre appareil',
  ],
};

const Assistance = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();
  const initialQuestion = params.get('q') || '';
  const intent = params.get('intent');
  const isSetup = intent === 'setup_iptv';
  const campaign = params.get('campaign') || null;

  useEffect(() => {
    // Reprise depuis l'e-mail de relance : si non connecté, on conserve l'intention.
    if (isSetup && !loading && !isAuthenticated) {
      const camp = campaign ? `&campaign=${campaign}` : '';
      const returnTo = encodeURIComponent(`/assistance?intent=setup_iptv${camp}`);
      navigate(`/connexion?returnTo=${returnTo}`, { replace: true });
    }
  }, [isSetup, loading, isAuthenticated, navigate, campaign]);

  // Suivi de conversion campagne : arrivée sur Nova depuis la campagne.
  useEffect(() => {
    if (campaign && isAuthenticated && !loading) {
      sessionStorage.setItem('nova_campaign_source', campaign);
      import('../services/api').then(({ default: api }) => {
        api.post('/assistant/campaign-event', { event: 'opened_nova', campaign }).catch(() => {});
      });
    }
  }, [campaign, isAuthenticated, loading]);

  return (
    <div className="min-h-screen bg-[#0A0A0B]" data-testid="assistance-page">
      <Helmet>
        <title>Nova — Assistante Support IPTV4KFR</title>
        <meta name="description" content="Nova, votre assistante virtuelle : diagnostic interactif, tutoriels et vidéos pour installer, configurer et dépanner votre service IPTV." />
      </Helmet>

      <div className="max-w-6xl mx-auto px-2 sm:px-4 pt-16 pb-4">
        <div
          className="relative bg-[#121214] border border-[#3A3A3D] rounded-2xl overflow-hidden"
          style={{ height: 'calc(100vh - 6rem)' }}
        >
          <AssistantChat
            initialQuestion={initialQuestion}
            initialAssistant={isSetup && isAuthenticated ? SETUP_WELCOME : null}
            pageContext={isSetup ? { route: '/assistance', page_type: 'setup_iptv', intent: 'setup_iptv', campaign_source: campaign } : null}
          />
        </div>
      </div>
    </div>
  );
};

export default Assistance;
